// @ts-nocheck
import React, { lazy } from 'react';
import { FormattedMessage as T } from '@/components';
import { Dialog, DialogSuspense } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const SalesPeopleFormDialogContent = lazy(() =>
  import('./SalesPeopleFormDialogContent'),
);

/**
 * Currency form dialog.
 */
function SalesPeopleFormDialog({
  dialogName,
  // payload = { action: '', id: null, currency: '' },
  payload = { action: '', id: null, salesPerson: null },
  isOpen,
}) {
  return (
    <Dialog
      name={dialogName}
      title={
        payload.action === 'edit' ? null : (
          <T id={'new_Salesperson'} />
        )
      }
      className={'dialog--currency-form'}
      isOpen={isOpen}
      autoFocus={true}
      canEscapeKeyClose={true}
      style={{ width: '1200px', minHeight: '800px' }}
    >
      <DialogSuspense>
        <SalesPeopleFormDialogContent
          dialogName={dialogName}
          salesPerson={payload.salesPerson}
          action={payload.action}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(SalesPeopleFormDialog);
